import React from 'react'
import { Row, Col, FormGroup, Label, Input, Switch } from 'twyne-new.ui';

const OptintelligenceForm = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Pub ID</Label>
          <Input type="text" value={data.pubid || ''}
            onChange={(e) => onChange('pubid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Non-Submit</Label>
          <Switch
            onChange={(e) => onChange('nonsubmit', e.target.checked)}
            checked={data.nonsubmit || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="3">
        <FormGroup>
          <Label>Submit Button</Label>
          <Switch
            onChange={(e) => onChange('submitbutton', e.target.checked)}
            checked={data.submitbutton || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default OptintelligenceForm;